"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const element_ui_1 = require("element-ui");
const vue_demi_1 = require("vue-demi");
// 引入 Element UI 组件样式
const webapi_1 = require("@fegobull/webapi");
require("element-ui/lib/theme-chalk/option.css");
require("element-ui/lib/theme-chalk/select.css");
const i18n_1 = tslib_1.__importDefault(require("../../../i18n"));
const utils_1 = require("../../common/utils");
const DatePickerDropdown_vue_1 = tslib_1.__importDefault(require("./DatePickerDropdown.vue"));
const DatePickerPopup_vue_1 = tslib_1.__importDefault(require("./DatePickerPopup.vue"));
const PopupSelect_vue_1 = tslib_1.__importDefault(require("./PopupSelect.vue"));
const TimeSlotPopup_vue_1 = tslib_1.__importDefault(require("./TimeSlotPopup.vue"));
// import request from '../assets/scripts/request';
const { usePageType } = webapi_1.use;
exports.default = (0, vue_demi_1.defineComponent)({
    name: 'ReservationForm',
    components: {
        ElSelect: element_ui_1.Select,
        ElOption: element_ui_1.Option,
        DatePickerDropdown: DatePickerDropdown_vue_1.default,
        DatePickerPopup: DatePickerPopup_vue_1.default,
        TimeSlotPopup: TimeSlotPopup_vue_1.default,
        PopupSelect: PopupSelect_vue_1.default
    },
    props: {
        configData: {
            type: Object,
            required: true
        },
        moduleName: {
            type: String,
            required: true
        },
        // 用户已有的预约记录列表（用于判断时段是否已预约）
        reservationList: {
            type: Array,
            default: () => []
        }
    },
    emits: ['submit', 'view-records'],
    // eslint-disable-next-line max-lines-per-function
    setup(props, { emit }) {
        const { isPC } = usePageType();
        // 是否有预约记录
        const hasReservationRecords = (0, vue_demi_1.computed)(() => {
            return props.reservationList.length > 0;
        });
        // 查看预约记录
        const handleViewRecords = () => {
            emit('view-records');
        };
        // 弹窗显示状态（移动端使用）
        const datePickerVisible = (0, vue_demi_1.ref)(false);
        const timeSlotPickerVisible = (0, vue_demi_1.ref)(false);
        // 表单数据
        const formData = (0, vue_demi_1.ref)({
            activityKey: '',
            date: '',
            rangeKey: '',
            ext1: null, // 单选时是字符串，多选时是数组
            ext2: null // 单选时是字符串，多选时是数组
        });
        // 表单配置
        const formConfig = (0, vue_demi_1.computed)(() => {
            return props.configData.formConfig || [];
        });
        // 是否有表单项目
        const hasFormItems = (0, vue_demi_1.computed)(() => {
            return formConfig.value && formConfig.value.length > 0;
        });
        // 活动列表
        const activityList = (0, vue_demi_1.computed)(() => {
            return props.configData.list || [];
        });
        // 是否有 date 字段
        const hasDateField = (0, vue_demi_1.computed)(() => {
            return formConfig.value.some((item) => item.field === 'date');
        });
        // rangeKey 配置项
        const rangeConfigItem = (0, vue_demi_1.computed)(() => {
            return formConfig.value.find((item) => item.field === 'rangeKey');
        });
        // 当前选中的活动
        const selectedActivity = (0, vue_demi_1.computed)(() => {
            if (!formData.value.activityKey) {
                return null;
            }
            return activityList.value.find((item) => item.activityKey === formData.value.activityKey);
        });
        // 当前选中的日期对应的 DateSlot
        const selectedDateSlot = (0, vue_demi_1.computed)(() => {
            if (!selectedActivity.value || !formData.value.date) {
                return null;
            }
            return selectedActivity.value.availableDates.find((item) => item.date === formData.value.date);
        });
        // activityKey 选项
        const activityOptions = (0, vue_demi_1.computed)(() => {
            return activityList.value.map((item) => {
                const name = (0, utils_1.getLocalText)(item.localText, 'name');
                return {
                    label: name || item.activityKey,
                    value: item.activityKey
                };
            });
        });
        // date 选项（根据语言自动选择日期格式）- 移动端使用
        const dateOptions = (0, vue_demi_1.computed)(() => {
            if (!selectedActivity.value) {
                return [];
            }
            return selectedActivity.value.availableDates.map((dateSlot) => {
                const formattedDate = (0, utils_1.formatDate)(dateSlot.date);
                return {
                    label: formattedDate,
                    value: dateSlot.date
                };
            });
        });
        /**
         * 检查指定时段是否已被用户预约（且未取消）
         */
        const isTimeSlotReserved = (activityKey, date, rangeKey) => {
            if (props.reservationList.length === 0) {
                return false;
            }
            return props.reservationList.some((record) => {
                // 匹配 activityKey + date + rangeKey
                const isMatch = record.activity_key === activityKey && record.date === date && record.range_key === rangeKey;
                // 未取消：canceled_at 为 0 或 null/undefined
                const isNotCanceled = !record.canceled_at || record.canceled_at === 0;
                return isMatch && isNotCanceled;
            });
        };
        // rangeKey 选项
        const rangeOptions = (0, vue_demi_1.computed)(() => {
            if (!selectedDateSlot.value) {
                return [];
            }
            const currentActivityKey = formData.value.activityKey;
            const currentDate = formData.value.date;
            return selectedDateSlot.value.timeRanges.map((timeSlot) => {
                // 使用 start 和 end 字段显示活动时间
                const timeStr = `${timeSlot.start} - ${timeSlot.end}`;
                // 判断是否禁用：已满、已过期、或已被预约
                const isFullOrExpired = timeSlot.status === 'full' || timeSlot.status === 'expired';
                const isReserved = isTimeSlotReserved(currentActivityKey, currentDate, timeSlot.rangeKey);
                const isDisabled = isFullOrExpired || isReserved;
                // 生成 label，如果 disabled 则在后面拼接原因（优先级：已预约 > 已满 > 已过期）
                let label = timeStr;
                if (isDisabled) {
                    let reason = '';
                    // 优先级：已预约 > 已满 > 已过期
                    if (isReserved) {
                        reason = (0, i18n_1.default)('time_slot_reserved');
                    }
                    else if (timeSlot.status === 'full') {
                        reason = (0, i18n_1.default)('time_slot_full');
                    }
                    else if (timeSlot.status === 'expired') {
                        reason = (0, i18n_1.default)('status_expired');
                    }
                    if (reason) {
                        label = `${timeStr} (${reason})`;
                    }
                }
                return {
                    label,
                    value: timeSlot.rangeKey,
                    disabled: isDisabled
                };
            });
        });
        /**
         * 初始化时自动选中唯一选项（仅按配置数量判断，不校验时段状态）
         */
        const autoSelectSingleOptions = () => {
            let activity = null;
            if (activityList.value.length === 1 && !formData.value.activityKey) {
                formData.value.activityKey = activityList.value[0].activityKey;
            }
            if (formData.value.activityKey) {
                activity = activityList.value.find((item) => item.activityKey === formData.value.activityKey);
            }
            else if (activityList.value.length === 1) {
                activity = activityList.value[0];
            }
            if (!(activity === null || activity === void 0 ? void 0 : activity.availableDates)) {
                return;
            }
            const availableDates = activity.availableDates;
            if (availableDates.length === 1 && !formData.value.date) {
                formData.value.date = availableDates[0].date;
            }
            const targetDate = formData.value.date || (availableDates.length === 1 ? availableDates[0].date : '');
            const dateSlot = availableDates.find((item) => item.date === targetDate);
            if (!(dateSlot === null || dateSlot === void 0 ? void 0 : dateSlot.timeRanges)) {
                return;
            }
            if (dateSlot.timeRanges.length === 1 && !formData.value.rangeKey) {
                formData.value.rangeKey = dateSlot.timeRanges[0].rangeKey;
            }
        };
        /**
         * 在 DOM 更新后触发级联自动填充（项目 → 日期 → 时段）
         */
        const scheduleAutoSelectSingleOptions = () => {
            (0, vue_demi_1.nextTick)(() => {
                autoSelectSingleOptions();
            });
        };
        // 是否可以提交
        const canSubmit = (0, vue_demi_1.computed)(() => {
            return Boolean(formData.value.activityKey && formData.value.date && formData.value.rangeKey);
        });
        // 日期是否可选择（需要先选择 activityKey）
        const canSelectDate = (0, vue_demi_1.computed)(() => {
            return Boolean(formData.value.activityKey);
        });
        // 时段是否可选择（需要先选择日期）
        const canSelectTimeSlot = (0, vue_demi_1.computed)(() => {
            return Boolean(formData.value.date);
        });
        // 提交按钮文案
        const submitBtnText = (0, vue_demi_1.computed)(() => {
            return (0, i18n_1.default)('submitBtn');
        });
        /**
         * 获取 placeholder
         */
        const getPlaceholder = (configItem) => {
            const placeholder = (0, utils_1.getLocalText)(configItem.localText, 'placeholder');
            if (placeholder) {
                return placeholder;
            }
            // 如果没有配置 placeholder，使用默认值
            const field = configItem.field;
            if (field === 'activityKey') {
                return (0, i18n_1.default)('placeholder_activity');
            }
            if (field === 'date') {
                return (0, i18n_1.default)('placeholder_date');
            }
            if (field === 'rangeKey') {
                return (0, i18n_1.default)('placeholder_time');
            }
            if (field === 'ext1') {
                return (0, i18n_1.default)('placeholder_ext1');
            }
            if (field === 'ext2') {
                return (0, i18n_1.default)('placeholder_ext2');
            }
            return '';
        };
        /**
         * 获取 ext1/ext2 的选项
         * value 使用 option.key，label 使用对应语言的文本
         */
        const getExtOptions = (configItem) => {
            if (!configItem.options || !Array.isArray(configItem.options)) {
                return [];
            }
            return configItem.options.map((option) => {
                const label = (0, utils_1.getFormOptionText)(option);
                return {
                    label: label || '',
                    value: option.key
                };
            });
        };
        /**
         * 处理 activityKey 变化
         */
        const handleActivityChange = () => {
            // 清空下级选择
            formData.value.date = '';
            formData.value.rangeKey = '';
            scheduleAutoSelectSingleOptions();
        };
        /**
         * 处理 date 变化
         */
        const handleDateChange = () => {
            // 清空 rangeKey
            formData.value.rangeKey = '';
            scheduleAutoSelectSingleOptions();
        };
        /**
         * 处理 PC 端日期选择变化
         */
        const handlePcDateChange = (date) => {
            formData.value.date = date;
            handleDateChange();
        };
        /**
         * 处理 rangeKey 变化
         */
        const handleRangeChange = () => {
            // 不需要特殊处理
        };
        /**
         * 获取日期显示文本（用于移动端触发按钮）
         */
        const getDateDisplayText = () => {
            if (!formData.value.date) {
                const dateConfigItem = formConfig.value.find((item) => item.field === 'date');
                return getPlaceholder(dateConfigItem);
            }
            const selectedOption = dateOptions.value.find((item) => item.value === formData.value.date);
            return selectedOption ? selectedOption.label : '';
        };
        /**
         * 获取时段显示文本（用于移动端触发按钮）
         */
        const getTimeSlotDisplayText = () => {
            if (!formData.value.rangeKey) {
                return getPlaceholder(rangeConfigItem.value);
            }
            const selectedOption = rangeOptions.value.find((item) => item.value === formData.value.rangeKey);
            return selectedOption ? selectedOption.label : '';
        };
        /**
         * 获取日期样式
         */
        const getDateStyle = () => {
            const dateConfigItem = formConfig.value.find((item) => item.field === 'date');
            return (dateConfigItem === null || dateConfigItem === void 0 ? void 0 : dateConfigItem.dateStyle) || 'monthFirst';
        };
        /**
         * 处理日期确认（移动端弹窗）
         */
        const handleDateConfirm = (date) => {
            formData.value.date = date;
            handleDateChange();
        };
        /**
         * 处理时段确认（移动端弹窗）
         */
        const handleTimeSlotConfirm = (rangeKey) => {
            formData.value.rangeKey = rangeKey;
            handleRangeChange();
        };
        /**
         * 处理日期点击（校验是否可选择）
         */
        const handleDateClick = () => {
            if (!canSelectDate.value) {
                // Toast.info($t('toast_select_activity_first'));
                return;
            }
            datePickerVisible.value = true;
        };
        /**
         * 处理时段点击（校验是否可选择）
         */
        const handleTimeSlotClick = () => {
            if (!canSelectDate.value) {
                // Toast.info($t('toast_select_activity_first'));
                return;
            }
            if (!canSelectTimeSlot.value) {
                // Toast.info($t('toast_select_date_first'));
                return;
            }
            timeSlotPickerVisible.value = true;
        };
        /**
         * 处理提交
         */
        const handleSubmit = async () => {
            if (!canSubmit.value) {
                return;
            }
            try {
                const submitData = {
                    moduleName: props.moduleName,
                    activityKey: formData.value.activityKey,
                    date: formData.value.date,
                    rangeKey: formData.value.rangeKey,
                    // eslint-disable-next-line max-len
                    ext1: (formData.value.ext1 &&
                        (Array.isArray(formData.value.ext1)
                            ? formData.value.ext1.join(',')
                            : formData.value.ext1)) ||
                        undefined,
                    // eslint-disable-next-line max-len
                    ext2: (formData.value.ext2 &&
                        (Array.isArray(formData.value.ext2)
                            ? formData.value.ext2.join(',')
                            : formData.value.ext2)) ||
                        undefined
                };
                // TODO: 调用创建预约接口
                // const { request } = require('../assets/scripts/request');
                // await request.createReservation(submitData);
                // 触发提交事件
                emit('submit', submitData);
            }
            catch (error) {
                console.error('[common-reservation] 提交预约失败:', error);
            }
        };
        // Watch for changes in configData to reset form and auto-select single options
        (0, vue_demi_1.watch)(() => props.configData, (newVal) => {
            if (newVal) {
                formData.value = {
                    activityKey: '',
                    date: '',
                    rangeKey: '',
                    ext1: null,
                    ext2: null
                };
                // 数据加载完成后，尝试自动选中唯一选项
                scheduleAutoSelectSingleOptions();
            }
        }, { immediate: true });
        /**
         * 根据 formConfig 中的 selectMode 转换 ext 字段值
         * 如果是多选模式且值为逗号分隔字符串，则转回数组
         * @param field 字段名（ext1 或 ext2）
         * @param value 待转换的值
         * @returns 转换后的值
         */
        const convertExtValue = (field, value) => {
            if (value === null) {
                return null;
            }
            // 如果已经是数组，无需转换
            if (Array.isArray(value)) {
                return value;
            }
            // 查找 formConfig 中对应字段的配置
            const configItem = formConfig.value.find((item) => item.field === field);
            // 如果是多选模式，将逗号分隔字符串转为数组
            if (configItem && configItem.selectMode === 'multiple' && typeof value === 'string') {
                return value.split(',');
            }
            return value;
        };
        /**
         * 设置表单数据（用于恢复缓存的表单草稿）
         * @param data 表单数据
         * @param data.activityKey 活动标识
         * @param data.date 预约日期
         * @param data.rangeKey 时段标识
         * @param data.ext1 扩展字段1
         * @param data.ext2 扩展字段2
         */
        const setFormData = (data) => {
            if (data.activityKey !== undefined) {
                formData.value.activityKey = data.activityKey;
            }
            if (data.date !== undefined) {
                formData.value.date = data.date;
            }
            if (data.rangeKey !== undefined) {
                formData.value.rangeKey = data.rangeKey;
            }
            if (data.ext1 !== undefined) {
                formData.value.ext1 = convertExtValue('ext1', data.ext1);
            }
            if (data.ext2 !== undefined) {
                formData.value.ext2 = convertExtValue('ext2', data.ext2);
            }
            // 恢复草稿后补全唯一日期/时段
            scheduleAutoSelectSingleOptions();
        };
        /**
         * 获取当前表单数据
         * @returns 表单数据
         */
        const getFormData = () => {
            return Object.assign({}, formData.value);
        };
        return {
            $t: i18n_1.default,
            isPC,
            datePickerVisible,
            timeSlotPickerVisible,
            // PC 端日期选择
            handlePcDateChange,
            // 表单相关
            formData,
            formConfig,
            hasFormItems,
            activityList,
            hasDateField,
            rangeConfigItem,
            selectedActivity,
            selectedDateSlot,
            activityOptions,
            dateOptions,
            rangeOptions,
            canSubmit,
            canSelectDate,
            canSelectTimeSlot,
            submitBtnText,
            getPlaceholder,
            getExtOptions,
            getDateDisplayText,
            getTimeSlotDisplayText,
            getDateStyle,
            handleActivityChange,
            handleDateChange,
            handleDateConfirm,
            handleDateClick,
            handleRangeChange,
            handleTimeSlotConfirm,
            handleTimeSlotClick,
            handleSubmit,
            // 预约记录按钮
            hasReservationRecords,
            handleViewRecords,
            // 暴露给父组件使用
            setFormData,
            getFormData,
            autoSelectSingleOptions
        };
    }
});
//# sourceMappingURL=data:application/json;base64,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